<script setup>
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import { ref } from 'vue'
import {getBannerApi, getNewsArticleQueryApi} from '@/api/index'
const info =ref({})
const bannerList = ref([

])
function getNewsArticleQuery (){
  getNewsArticleQueryApi({type:2}).then(res =>{
    info.value = res.data
  })
}
function  getBanner (){
  getBannerApi({type:2}).then(res => {
    bannerList.value = res.data
  })
}
getNewsArticleQuery()
getBanner()
</script>
<template>
  <div class="box">
    <HeaderNav :isCurrent="1" />
    <div>
      <!-- 轮播图 -->
      <el-carousel height="600px" autoplay>
        <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
          <img :src="item.picUrl" :alt="item.title">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div>
    <div class="single">
      <!--右侧区域 开始-->
      <div id="right">
        <div class="right_title">
          <!--当前位置 开始-->
          <div id="location">
            <a href="/" target="_self">{{ t('首页') }}</a> &nbsp;&gt;&gt;&nbsp;
            <a href="javascript:;">{{ t('发展历史') }}</a>
          </div>
        </div>
        <div id="subchannel_main">
          <div id="subchannel">
            <ul class="subchannellist">
              <li class="depth1" id="current">
                <a href="javascript:;">{{ t('发展历史') }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="right_body minwidth">
          <div class="ChannelContent">
            <div v-html="info.content"></div>
            <!-- <p>最初挖掘机是手动的，从发明到2013年已经有一百三十多年了，期间经历了由蒸汽驱动斗回转挖掘机到电力驱动和内燃机驱动回转挖掘机、应用机电液一体化技术的全自动液压挖掘机的逐步发展过程。第一台液压挖掘机由法国波克兰工厂发明成功。由于液压技术的应用，20世纪40年代有了在拖拉机上配装液压反铲地悬挂式挖掘机。1951 年，第一台全液压反铲挖掘机由位于法国的 Poclain（波克兰）工厂推出，从而在挖掘机的技术发展领域开创了全新空间，20世纪50年代初期和中期相继研制出拖式全回转液压挖掘机和履带式全液压挖掘机。初期试制的液压挖掘机是采用飞机和机床的液压技术，缺少适用于挖掘机各种工况的液压元件，制造质量不够稳定，配套件也不齐全。从20世纪60年代起，液压挖掘机进入推广和蓬勃发展阶段，各国挖掘机制造厂和品种增加很快，产量猛增。1968-1970年间，液压挖掘机产量已占挖掘机总产量的83%，已接近100% [2] 。</p><p>第一代挖掘机：电动机、内燃机的出现，使挖掘机有了先进而合适的电动装置，于是各种挖掘机产品相继诞生。1899年，第一台电动挖掘机出现了。第一次世界大战后，柴油发动机也应用在挖掘机上，这种柴油发动机（或电动机）驱动的机械式挖掘机是第一代挖掘机。</p><p>第二代挖掘机：随着液压技术的广泛使用，使挖掘机有了更加科学适用的传动装置，液压传动代替机械传动是挖掘机技术上的一次大飞跃。1950年德国的第一台液压挖掘机诞生了。机械传动液压化是第二代挖掘机。</p><p>第三代挖掘机：电子技术尤其是计算机技术的广泛应用，使挖掘机有了自动化的控制系统，也使挖掘机向高性能、自动化和智能化方向发展。机电一体化的萌芽约发生在1965年前后，而在批量生产的液压挖掘机上采用机电一体化技术则在1985年左右，当时主要目的是为了节能。挖掘机电子化是第三代挖掘机的标志。</p><p>挖掘机行业厂商大致可以分为四类。国内7成以上挖掘机被国外品牌所占据，国产品牌尚以小挖和中挖为主，但国产挖掘机份额正在逐步提升，2012年同比提高3.6%。</p> -->
            <p><br/></p>
          </div>
        </div>
        <div class="right_bottom"></div>
      </div>
      <!--右侧区域 结束-->
      <div class="clear"></div>
    </div>
  </div>
    <div>
      <FootNav />
    </div>
  </div>
</template>
